

import { combineReducers } from 'redux';
import mining from './block-mining-reducer.js';
import hash from './hash-reducer.js';
import merkle from './merkle-reducer.js';
import transaction from './transactions-reducer.js';
import publicKey from './publickey-reducer.js';

const mainReducer = combineReducers({
    mining,
    hash,
    merkle,
    transaction,
    publicKey,
});

export { mainReducer as default };





// WEBPACK FOOTER //
// ./src/reducers/index.js